import React from 'react';

type TInfoProps = {
  title: string;
  value: string | number | boolean | React.JSX.Element;
};

export const SystemInfoItem = (props: TInfoProps) => {
  const { title, value } = props;

  return (
    <li>
      <strong>{title}</strong>
      {value}
    </li>
  );
};
